import { Dimensions } from 'react-native';
import imageResizer from "@comps/Resizer";

export async function resizeFile(file: any) {
    return new Promise((resolve) => {
        // Preserva o formato original para manter transparência
        const originalFormat = file.type?.includes('png') ? 'png' : 'jpeg';
        
        imageResizer.imageFileResizer({
            file,
            maxWidth: 1920,
            maxHeight: 1080,
            keepAspectRatio: true,
            compressFormat: originalFormat,
            quality: 80,
            responseUriFunc: (uri: string) => {
                resolve(uri as string);
            }
        })
    })
}


export function dataURLtoBlob(dataURL: string) {
    const arr = dataURL.split(',');
    const mime = arr[0].match(/:(.*?);/)![1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
};



export function calculateImageSize(width: number, height: number, padding: number = 32) {
    const screenWidth = Dimensions.get('window').width;
    const newWidth = screenWidth - padding; // Subtrai o padding total da largura da tela
    const aspectRatio = width / height; // Proporção original da imagem
    const newHeight = newWidth / aspectRatio; // Calcula a nova altura mantendo a proporção

    return {
        width: newWidth,
        height: newHeight
    };
}
